<template>
  <div>
    <div
      v-if="!showPrompt"
      class="content payment"
      :class="{
        'mobile-payment-cont': showH5Style,
        'pad-app-payment-cont': isMGAppInPad,
      }"
    >
      <div class="content-wrap order-info" v-if="!showH5Style">
        <div class="left-wrap">
          <p class="time">
            请在<span>{{
              moment(orderInfo.timeout_at * 1000).format("YYYY-MM-DD HH:mm:ss")
            }}</span
            >前完成支付，逾期订单将失效
          </p>
          <p class="order-no">交易单号：{{ orderInfo.order_no }}</p>
        </div>
        <p class="price">￥{{ orderInfo.real_price / 100 }}</p>
      </div>
      <div class="content-wrap pay-type" v-if="!showH5Style">
        <hr style="margin-bottom: 40px" />
        <p class="title">支付方式</p>
        <ul class="type">
          <li
            :class="{ active: payType === item.type }"
            v-for="item in payList"
            :key="item.type"
            @click="changePayType(item.type)"
          >
            <img
              :src="require('@/assets/img/payment/' + item.imgName)"
              :alt="item.name"
            />
          </li>
        </ul>
        <p class="pay-btn">
          <el-button
            class="btn-pay"
            type="primary"
            @click="startPay"
            :disabled="orderInfo.state !== 1 || btnLoading"
            v-preventReClick
          >
            <slot v-if="orderInfo.state == 1"> 立即支付 </slot>
            <slot v-else>{{ stateList[orderInfo.state] }}</slot>
          </el-button>
        </p>
      </div>
      <!-- 移动 -->
      <mobile-top
        v-if="showH5Style && orderInfo.order_no"
        :timeout-at="orderInfo.timeout_at"
        :price="orderInfo.real_price / 100"
        :title="orderInfo.goods_title"
        :orderNo="orderInfo.order_no"
        :startPay="startPay"
      ></mobile-top>
      <div
        class="content-wrap pay-type"
        v-if="showH5Style && orderInfo.order_no"
      >
        <p class="title">支付方式</p>
        <ul class="type-mobile visible-xs">
          <li
            :class="{ active: payType === item.type }"
            v-for="item in payList"
            :key="item.type"
            @click="changePayType(item.type)"
          >
            <img
              :src="require('@/assets/img/payment-h5/' + item.imgName)"
              :alt="item.name"
            />
            <span>{{ item.name }}支付</span>
          </li>
        </ul>
        <p class="pay-btn">
          <el-button
            class="btn-pay"
            type="primary"
            @click="startPay"
            :disabled="orderInfo.state !== 1 || btnLoading"
            v-preventReClick
          >
            <slot v-if="orderInfo.state == 1"> 立即支付 </slot>
            <slot v-else>{{ stateList[orderInfo.state] }}</slot>
          </el-button>
        </p>
      </div>
    </div>
    <prompt-page v-else :msgInfo="promptMsg" :orderInfo="orderInfo" />
    <pay-dialog ref="payDialog" @closeDialog="handleCloseDialog" />
  </div>
</template>

<script>
// import pingpp from "pingpp-js";
import qrcode from "qrcode";
import { PromptPage, isHXApp, isMGAppInPad, isH5 } from "@saas/components/src";
import { ORDER_STATE } from "@saas/components/src/utils/constants.js";
import { isMobile, isWeChat } from "@saas/components/src/utils/utils";
import moment from "moment";
import {
  getOrder,
  chargeOrder,
  getWxMiniProgramUrl,
} from "@saas/service-api/src/product-details";
import { getToken } from "@saas/service-api/src/plugins/auth";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import PayDialog from "./components/PayDialog";
import MobileTop from "./components/MobileTop.vue";
import { openAlipay, openWxMiniProgram } from "./util";
import {
  nativeBridge,
  isMiniProgramContainer,
} from "@saas/components/src/utils/native-bridge";
import { refreshToken } from "@saas/service-api/src/request.js";
const YEEPAY_CHANNEL = {
  aliPc: "yeepay_alipay_qr",
  wxPc: "yeepay_wx_pub_qr",
  wxLiteOfl: "yeepay_wx_lite_ofl",
  aliMobile: "yeepay_alipay_qr",
};
export default {
  data: function () {
    return {
      moment,
      payType: "alipay",
      // payList: [
      //   { type: "alipay", imgName: "alipay.png", name: "支付宝" },
      //   { type: "wechat", imgName: "wx-pay.png", name: "微信" },
      // ],
      orderInfo: {},
      stateList: ORDER_STATE,
      promptMsg: {},
      showPrompt: false, //异常提示页
      btnLoading: false, //支付按钮
      orderTimer: false,
      isMobile: false,
      isWeChat: false,
      isHXApp: false,
      isH5: false,
      isMGAppInPad: false,
      showH5Style: false,
    };
  },
  computed: {
    payList() {
      if (!this.isWeChat) {
        return [
          { type: "wechat", imgName: "wx-pay.png", name: "微信" },
          { type: "alipay", imgName: "alipay.png", name: "支付宝" },
        ];
      } else {
        return [{ type: "wechat", imgName: "wx-pay.png", name: "微信" }];
      }
    },
  },
  mounted() {
    this.isMGAppInPad = isMGAppInPad();
    this.isWeChat = isWeChat();
    this.isMobile = isMobile();
    this.isHXApp = isHXApp();
    this.isH5 = isH5();
    this.showH5Style = this.isHXApp || this.isH5;
    // 获取订单详情
    this.apiGetOrder();
    document.title = "支付中心";
    jsToFlutter("setTitle", { title: document.title });
    if (this.isWeChat) {
      this.payType = "wechat";
    }
  },
  methods: {
    changePayType(type) {
      if (this.btnLoading) return;
      this.payType = type;
    },
    apiGetOrder() {
      getOrder({ order_no: this.$route.params.order_no }).then((res) => {
        if (res.code === 1) {
          this.orderInfo = res.data || {};
          let state = this.orderInfo.state;
          if (state !== 1) {
            this.promptMsg = {
              linkList: [
                {
                  routeName: "Home",
                  name: "官网",
                },
                {
                  routeName: "Trade",
                  name: "交易订单",
                },
              ],
            };
            if (state === 2) {
              this.promptMsg.type = "success";
              this.promptMsg.msg = "订单已完成，无法重复处理。";
            } else if (state === 3 || state === 4) {
              this.promptMsg.type = "error";
              this.promptMsg.msg = "订单已关闭，无法重复处理。";
            }
            this.showPrompt = true;
          }
        } else if (res.code === 6666) {
          this.promptMsg = {
            type: "error",
            msg: "您访问的页面不存在。",
            linkList: [
              {
                routeName: "Home",
                name: "官网",
              },
              {
                routeName: "myCourse",
                name: "学习中心",
              },
            ],
          };
          this.showPrompt = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    startPay() {
      if (this.btnLoading) return;
      this.btnLoading = true;
      if (isMiniProgramContainer() && !isHXApp() && this.payType === "wechat") {
        return this.payInMiniProgram();
      }
      let params = {
        channel: this.getChannel(),
        order_no: this.orderInfo.order_no,
      };
      if (this.orderInfo.activity_type === 1) {
        params.coupon_id = this.orderInfo.activity_id;
      }
      if (this.isMobile && !isHXApp() && this.payType === "wechat") {
        // 微信支付 手机端并且不是魔果app，通过拉起魔果云课小程序支付
        this.getWxMiniProgramUrl();
      } else {
        chargeOrder(params)
          .then((res) => {
            if (res.code === 1) {
              const channelMethod =
                params.channel + "_" + (this.isMobile ? "mobile" : "");
              console.log(channelMethod, "channelMethod=====");

              this.handleCreateOrder(channelMethod, res.data);
            } else {
              this.$message.warning(res.message);
            }
            this.btnLoading = false;
          })
          .catch(() => {
            this.btnLoading = false;
          });
      }
    },
    // 仅处理当前小程序 web-view 内的原生支付。
    async payInMiniProgram() {
      try {
        const res = await refreshToken();
        if (res.code !== 1 || !res.data?.access_token) {
          this.$message.warning(res.message || "登录已过期，请重新登录后支付");
          return;
        }
        const params = {
          order_no: this.orderInfo.order_no,
          token: res.data.access_token,
        };
        const opened = await nativeBridge.openPayment(params);
        if (!opened) {
          this.$message.warning("请在小程序内重新打开支付页面");
          return;
        }
        clearInterval(this.orderTimer);
        this.orderTimer = setInterval(() => {
          this.queryOrderState();
        }, 2000);
      } catch (error) {
        this.$message.warning(error?.message || "打开微信支付失败，请重试");
      } finally {
        this.btnLoading = false;
      }
    },
    // 获取魔果云课微信小程序支付地址
    getWxMiniProgramUrl() {
      refreshToken()
        .then((res) => {
          if (res.code === 1) {
            const params = {
              order_no: this.orderInfo.order_no,
              token: res.data.access_token,
            };
            getWxMiniProgramUrl({
              path: "/pages/pay/index",
              query: `order_no=${params.order_no}&token=${encodeURIComponent(
                params.token
              )}`,
            })
              .then((res) => {
                if (res.code === 1) {
                  // 唤起微信小程序支付
                  openWxMiniProgram(res.data);
                  this.orderTimer = setInterval(() => {
                    this.queryOrderState();
                  }, 2000);
                } else {
                  this.$message.warning(res.message);
                }
              })
              .finally(() => {
                this.btnLoading = false;
              });
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    // 处理支付逻辑
    handleCreateOrder(channelMethod, data) {
      if (channelMethod === YEEPAY_CHANNEL.wxLiteOfl + "_mobile") {
        this.handleWxMiniProgram(data);
      } else if (channelMethod === YEEPAY_CHANNEL.aliMobile + "_mobile") {
        // 支付宝支付h5
        this.handleAlipayMobile(data);
      } else {
        // 都二维码扫码
        this.qRCodePay(data);
      }
    },
    // 微信小程序支付
    handleWxMiniProgram(data) {
      const { credential = {} } = data.charge_essentials;
      const { yeepay_wx_lite_ofl } = credential;
      if (yeepay_wx_lite_ofl) {
        openWxMiniProgram(yeepay_wx_lite_ofl);
        this.orderTimer = setInterval(() => {
          this.queryOrderState();
        }, 2000);
      }
    },
    handleAlipayMobile(data) {
      try {
        this.$message.info("正在打开支付宝...");
        openAlipay(data);
        this.orderTimer = setInterval(() => {
          this.queryOrderState();
        }, 2000);
      } catch (error) {
        this.$message.error("支付失败:", error);
      }
    },
    qRCodePay(data = {}) {
      const channel = this.getChannel();
      const charges = (data.charges?.data || []).find(
        (item) => item.credential && item.credential[channel]
      );
      let { credential = {} } = charges || {};
      console.log(charges, "charges======");

      const orderUrl = credential[channel];
      if (!orderUrl) return;
      let obj = {
        price: data.amount,
        payType: this.payType,
      };
      qrcode.toDataURL(orderUrl, { width: 156 }, (err, url) => {
        if (err) throw err;
        obj.qrcodeImg = url;
      });
      this.$refs["payDialog"].showDialog(obj);
      this.orderTimer = setInterval(() => {
        this.queryOrderState();
      }, 2000);
    },
    // 轮询订单状态
    queryOrderState() {
      getOrder({
        order_no: this.orderInfo.order_no,
        keep_alive: 1,
      }).then(
        (res) => {
          if (res.code === 1) {
            if (Number(res.data.state) === 2) {
              // 已支付
              // 报名成功-通知app-更新学习课程列表
              if (this.isHXApp) {
                jsToFlutter("joinSuccess");
              }
              this.stopQuery();
              if (this.orderInfo.activity_type === 4) {
                this.$router.push(`/group-info/${this.orderInfo.activity_id}`);
              } else {
                this.$router.push(`/pay-result/${this.orderInfo.order_no}`);
              }
            }
          } else {
            this.$message.warning(res.message);
          }
        },
        () => {
          // this.$message.error("支付失败");
        }
      );
    },
    // 停止轮询订单状态
    stopQuery() {
      this.$refs["payDialog"].handleClose();
      clearInterval(this.orderTimer);
    },
    handleCloseDialog() {
      clearInterval(this.orderTimer);
    },
    // 获取支付渠道
    getChannel() {
      let channel =
        this.payType === "alipay" ? YEEPAY_CHANNEL.aliPc : YEEPAY_CHANNEL.wxPc;
      if (this.isMobile) {
        channel =
          this.payType === "alipay"
            ? YEEPAY_CHANNEL.aliMobile
            : YEEPAY_CHANNEL.wxLiteOfl;
      }
      // if (this.payType === "wechat" && !this.wechat && this.isMobile) {
      //   channel = "wx_wap";
      // }
      // if (this.payType === "alipay" && !this.wechat && this.isMobile) {
      //   channel = "alipay_wap";
      // }
      return channel;
    },
  },
  beforeDestroy() {
    clearInterval(this.orderTimer);
  },
  components: {
    "pay-dialog": PayDialog,
    "prompt-page": PromptPage,
    "mobile-top": MobileTop,
  },
};
</script>

<style lang="scss" scoped>
.payment.pad-app-payment-cont {
  max-width: 375px;
}
.payment {
  --payment-page-bg: var(--mg-bg-page);
  --payment-card-bg: var(--mg-bg-card);
  --payment-primary: var(--mg-text-primary);
  --payment-secondary: var(--mg-text-secondary);
  --payment-price: var(--mg-danger-primary);
  --payment-border: var(--mg-border-subtle);
  --payment-active-bg: var(--mg-bg-card);

  html.dark & {
    --payment-page-bg: var(--mg-bg-page);
    --payment-card-bg: var(--mg-bg-surface);
    --payment-primary: var(--mg-text-primary);
    --payment-secondary: var(--mg-text-secondary);
    --payment-price: var(--mg-danger-primary);
    --payment-border: var(--mg-border-subtle);
    --payment-active-bg: var(--mg-bg-elevated);
  }

  width: 100%;
  padding: 16px;
  height: 100vh;
  background: var(--payment-page-bg);
  color: var(--payment-primary);
}
.type {
  display: none !important;
}
.visible-xs {
  display: none !important;
}
@media screen and (min-width: 768px) {
  .payment {
    max-width: 768px;
    width: 100%;
    padding: 15px;
    .content-wrap {
      background: var(--payment-card-bg);
      padding: 20px;
    }
    .order-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--payment-secondary);

      .left-wrap {
        .time {
          font-size: 14px;
          margin-bottom: 16px;
          color: var(--payment-primary);
          span {
            color: $saas-theme-color;
            margin: 0 8px;
            font-weight: 600;
          }
        }

        .order-no {
          color: var(--payment-secondary);
        }
      }
      .price {
        color: var(--payment-price);
        font-size: 20px;
        font-weight: 600;
      }
    }
    .pay-type {
      padding-top: 0;
      .title {
        font-size: 14px;
        margin-bottom: 20px;
        color: var(--payment-primary);
      }
      .type {
        display: flex !important;
        justify-content: center;
        margin-bottom: 40px;
        li {
          cursor: pointer;
          position: relative;
          padding: 10px;
          border: 2px solid var(--payment-border);
          background: var(--payment-active-bg);
          margin: 0 10px;
          width: 240px;
          height: 160px;
          display: flex;
          justify-content: center;
          border-radius: 8px;
          img {
            width: 200px;
          }
        }
        .active {
          border: 2px solid $saas-theme-color;

          &::after {
            position: absolute;
            content: " ";
            display: block;
            left: 50%;
            bottom: -3px;
            transform: translateX(-50%);
            width: 226px;
            line-height: 32px;
            text-align: center;
            color: #fff;
            border-radius: 0 0 8px 8px;
            background: $saas-theme-color;
          }
        }
        // .fa-zhifubao {
        //   color: #00a0e9;
        // }
        // .fa-wx {
        //   color: #09bb07;
        // }
      }
      .pay-btn {
        text-align: center;
      }
      .btn-pay {
        width: 343px;
        border-radius: 20px;
        margin-bottom: 150px;
      }
    }
  }
}

// 移动端-适配
.mobile-payment-cont {
  &.payment {
    width: 100%;
    background: var(--payment-page-bg);
    padding: 0 0.32rem;
  }
  .visible-xs {
    display: block !important;
  }
  .pay-type {
    .title {
      font-weight: 400;
      font-size: 0.32rem;
      color: var(--payment-secondary);
      line-height: 0.44rem;
      margin-bottom: 0.28rem;
    }

    .type-mobile {
      background: var(--payment-card-bg);
      border-radius: 0.32rem;
      overflow: hidden;
      li {
        display: flex;
        align-items: center;
        height: 1.34rem;
        padding: 0 0.4rem 0 0.32rem;
        position: relative;
        font-weight: 400;
        font-size: 0.37rem;
        color: var(--payment-primary);
        line-height: 0.53rem;
        img {
          width: 0.48rem;
          display: inline-block;
          vertical-align: middle;
          margin-right: 0.16rem;
        }
      }
      li::after {
        position: absolute;
        content: " ";
        display: block;
        width: 0.37rem;
        height: 0.37rem;
        top: 50%;
        transform: translateY(-50%);
        right: 0.4rem;
        background: transparent;
        background: url("../../assets/images/un-check.png") center no-repeat;
        background-size: contain;
      }
      .active {
        &::after {
          border-color: $saas-theme-color;
          background: url("../../assets/images/checked.png") center no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .btn-pay {
    position: fixed;
    bottom: 0.8rem;
    left: 50%;
    transform: translateX(-50%);
    width: 9.36rem;
    margin: 0 auto 0.8rem;
    height: 1.33rem;
    border-radius: 0.32rem;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%) !important;
    border: none;
    font-size: 0.43rem;
  }
}

</style>
